import React, {useEffect} from 'react';

import {sendDesktopAnalyticsEvent} from '@optimaxdev/analytics/desktop/lib/sendAnalyticsEvent/index';
import {CtaButton} from '@optimaxdev/design-system';
import {useDispatch, useSelector} from 'react-redux';

import {VisiblyExamFail} from 'components/success/contacts/visiblyExamFail/visiblyExamFail';

import {TYP_CONTACT_LENSES} from 'constants/analytics/events/typ';
import {CL_RX_METHOD} from 'constants/success';

import {getVisiblyData} from 'desktop/pages/success/store/selectors/orderItems/orderItems';

import {getLabel} from 'libs/success/helpers/helpers';

import {setDrawerMethod} from '../../../store/reducers/drawerPopup/drawerPopup';
import {ScreenWrapper} from '../../contacts/screenWrapper/screenWrapper';

/**
 * Visibly exam fail wrapper for TYP desktop
 */
export const VisiblyExamFailWrapper = () => {
    const dispatch = useDispatch();
    const {
        errors: {message: failMessage},
        values: {state: selectedState},
    } = useSelector(getVisiblyData);

    useEffect(() => {
        sendDesktopAnalyticsEvent(
            TYP_CONTACT_LENSES,
            `${getLabel(CL_RX_METHOD.EYE_EXAM_ELIGIBILITY_FAILED)} - ${failMessage === 'age' ? 'Age' : 'State'}`,
            false,
        );
    }, []);

    const handleBack = () => {
        dispatch(setDrawerMethod({rxMethod: ''}));
        sendDesktopAnalyticsEvent(
            TYP_CONTACT_LENSES,
            `${getLabel(CL_RX_METHOD.EYE_EXAM_ELIGIBILITY_FAILED)} - Another confirmation method`,
        );
    };

    const handleRefillClicked = () => {
        dispatch(setDrawerMethod({rxMethod: CL_RX_METHOD.EYE_EXAM_ELIGIBILITY}));
        sendDesktopAnalyticsEvent(
            TYP_CONTACT_LENSES,
            `${getLabel(CL_RX_METHOD.EYE_EXAM_ELIGIBILITY_FAILED)} - Refill details`,
        );
    };

    return (
        <ScreenWrapper
            buttons={
                <CtaButton colorName="secondary" onClick={handleRefillClicked}>
                    Refill Details
                </CtaButton>
            }
        >
            <VisiblyExamFail
                errorMessage={failMessage || ''}
                handleBack={handleBack}
                selectedState={selectedState}
            />
        </ScreenWrapper>
    );
};
